// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-detail .ant-notification-notice {
    width: 285px !important;
    padding: 10px !important; /* Set your desired padding */
    margin: 10px !important; /* Set your desired margin */
  }`, "",{"version":3,"sources":["webpack://./src/Components/NotificationDetail/styles.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,wBAAwB,EAAE,6BAA6B;IACvD,uBAAuB,EAAE,4BAA4B;EACvD","sourcesContent":[".notification-detail .ant-notification-notice {\n    width: 285px !important;\n    padding: 10px !important; /* Set your desired padding */\n    margin: 10px !important; /* Set your desired margin */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
